<template>
  <div>
      <div class=" dropdown-header noti-title">
          <h6 class="text-overflow m-0">Welcome to Msacco!</h6>
      </div>
      <router-link to="/profile" class="dropdown-item">
          <i class="ni ni-single-02"></i>
          <span>My profile</span>
      </router-link>

      <div class="dropdown-divider"></div>
      <a class="dropdown-item" @click="logout">
          <i class="fa fa-power-off"></i>
          <span>Logout</span>
      </a>
  </div>
</template>

<script>
    export default {
        name: "RightSideBarContent",
        methods: {
            logout(){
                localStorage.clear();
                this.$router.push('login')
            }
        }
    }
</script>

<style scoped>

</style>
